<template>
  <div class="areas-list">
    <v-row align="center" class="pa-4 mb-2 areas-toolbar">
      <v-card-title class="areas-toolbar__title">Список районов</v-card-title>

      <div class="areas-toolbar__search">
        <BaseTextField
          v-model="filterName"
          type-input="string"
          :is-button="false"
          label="Название"
        />
      </div>

      <v-spacer />

      <div class="areas-toolbar__actions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer"
              v-bind="attrs"
              v-on="on"
              :loading="loading"
              @click="loadRegions"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Обновить</span>
        </v-tooltip>
      </div>
    </v-row>

    <v-data-table
      class="table"
      :headers="headersAreas"
      :items="filteredAreas"
      :loading="loading"
      item-key="id"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.city="{ item }">
        {{ displayCity(item.city_id) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="areas-table-actions" @click.stop>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                :to="getAreaDescriptionRoute(item)"
              >
                <v-icon size="large">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Описание района</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseTextField from '@/components/BaseTextField';

export default {
  name: 'RegionsList',
  components: { BaseTextField },
  data () {
    return {
      loading: false,
      filterName: '',
      headersAreas: [
        { text: 'Название', value: 'name' },
        { text: 'Город', value: 'city', sortable: false },
        { text: '', value: 'actions', width: '8%', sortable: false, align: 'center' },
      ],
    };
  },
  created () {
    this.loadRegions();
  },
  computed: {
    ...mapGetters({
      areas: 'Region/regions',
    }),
    filteredAreas () {
      if (!this.filterName) return this.areas;
      const query = this.filterName.toLowerCase();
      return this.areas.filter(area => area.name.toLowerCase().includes(query));
    },
  },
  methods: {
    ...mapActions({
      fetchRegions: 'Region/getRegions',
    }),
    async loadRegions () {
      this.loading = true;
      try {
        await this.fetchRegions();
      } catch (e) {
        this.$flash_warning('Не удалось загрузить районы');
      } finally {
        this.loading = false;
      }
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '—';
      }
    },
    getAreaDescriptionRoute (item) {
      return item?.id
        ? `/areas/area-description/${item.id}`
        : '/areas/area-description';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './areasList.scss';
</style>
